import * as React from 'react';
import { useEffect } from 'react';
import Top from "../Top";
import Bottom from "../Bottom";
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { useLocation, useNavigate } from "react-router-dom";
import { selfQuestionnaires } from "../../utils/selfQuestionnaires";
import { styled } from '@mui/material/styles';

import result1 from "../../assets/images/result1.png";
import result2 from "../../assets/images/result2.png";
import result3 from "../../assets/images/result3.png";
import result4 from "../../assets/images/result4.png";

import CheckMain from "./CheckMain";
import StateMissingFallback from "../../components/StateMissingFallback";

const SelfScoreSimple = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { selfQuestionNo, selfQuestionOriginalPoint, resultTitle } = state ?? {};

  useEffect(() => {

    return () => {
    }
  }, []);

  const ImageArr = [result1, result2, result3, result4,];
  const randomImg = Math.floor(Math.random() * ImageArr.length);
  const resultImg = ImageArr[randomImg];

  // state 없이 진입하면(새로고침·직접 URL 접근) 렌더할 데이터가 없다.
  // 아래에서 undefined 의 속성을 읽어 화면이 깨지므로 렌더하지 않는다.
  // state 가 없으면 백지 대신 빠져나갈 수 있는 안내를 보여준다
  if (!state) {
    return (
      <StateMissingFallback
        title="자가진단 결과"
        message={'결과 정보를 불러오지 못했습니다.\n자가진단을 다시 진행해 주세요.'}
        actionLabel="자가진단 목록으로"
        to="/check/SelfCheckList"
      />
    );
  }

  return (

    <Container sx={{ width: '100%', minWidth: 320, background: '#F1F2F4', p: 0, pb: 7, boxSizing: 'border-box' }} >
      <Top title="자가진단 결과" />

      <Box sx={{ pl: 2, pr: 2, }}>

        <Box sx={{ p: 2, pt: 8, mt: 2 }}>
          <Typography component="div" sx={{ fontSize: 18, color: '#555', textAlign: 'center', fontWeight: 700, mb: .5 }}>
            {selfQuestionnaires && selfQuestionnaires.filter((v: any) => v.no === selfQuestionNo)[0].title}
          </Typography>
          <Typography component="div" sx={{ fontSize: 16, color: '#777', textAlign: 'center', fontWeight: 700 }}>
            자가진단
          </Typography>
        </Box>

        <Box sx={{ bgcolor: '#fff', p: 2, mt: 1, mx: 2, borderRadius: 4, boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.12)', }}>


          <Stack direction={'column'} justifyContent={'center'} alignItems={'center'} sx={{}}>
            <Typography component="div" sx={{ fontSize: 16, fontWeight: 700, mb: 1, color: '#555' }}>
              {resultTitle}
            </Typography>
            <Typography component="div" sx={{ fontSize: 18, fontWeight: 700, mb: 1, color: '#ff0000' }}>
              {selfQuestionOriginalPoint}
            </Typography>
          </Stack>

        </Box>

        {selfQuestionnaires && selfQuestionnaires.filter((v: any) => v.no === selfQuestionNo)[0].intervention.map((item: any, index: any) => (
          <React.Fragment>
            {index === 0 ? (<Typography sx={{ mt: 4, fontWeight: 700, color: '#555' }}>치료 방법</Typography>) : (null)}
            <Box sx={{ bgcolor: '#fff', p: 2, m: 0, mt: 1, borderRadius: 4, boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.12)', }}>
              <Typography sx={{ fontSize: 14 }}>{item}</Typography>
            </Box>
          </React.Fragment>
        ))}

        <Box sx={{  mt:3 }} justifyContent='center' alignContent={'center'}>
          <Img alt="resultImg" src={resultImg} />
        </Box>


        <Box sx={BtnStyle}>
          <Button variant="contained" sx={BottomBtnStyle}
            onClick={() => navigate('../check/SelfCheckList')}
          >
            확인
          </Button>
        </Box>

      </Box>



      <React.Fragment>
        <Box sx={{ bgcolor: '#fff', p: 1, pl: 2, pr: 2, mt: 8 }}>
          <Typography sx={{ fontSize: 16, fontWeight: 700, color: '#555', pt: 1, mb: 1, pl: 2, }}>추천 자가진단 </Typography>
          <CheckMain />
        </Box>
      </React.Fragment>



      <Bottom />
    </Container>
  );
}

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});


const BtnStyle = {
  display: 'flex',
  justifyContent: 'center',
  mt: 7,
};

const BottomBtnStyle = {
  width: '100%',
  bgcolor: '#EF8322',
  fontSize: 18,
  fontWeight: 700,
  borderRadius: '30px',
  boxSizing: 'border-box',
  color: '#fff',
  border: '0px solid #ef8322',
  ':hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color: '#fff'
  },
  ':active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  ':focus': {
    boxShadow: 'none',
  },
};


export default SelfScoreSimple;